import LoneStarProviderReview from './LoneStarProviderReview';

export default LoneStarProviderReview;
